

// Tabs for Archive
const tabsContainer = document.querySelector('.tabs-container');
const tabsList = tabsContainer.querySelector('ul');
const tabButtons = tabsList.querySelectorAll('a');
const tabPanels = tabsContainer.querySelectorAll('.tabs-content > div');

tabsList.setAttribute('role', 'tablist');

tabsList.querySelectorAll('li').forEach((listItem) => {
    listItem.setAttribute('role', 'presentation');
});

tabButtons.forEach((tab, index) => {
    tab.setAttribute('role', 'tab');
    if (index === 0) {
    tab.setAttribute('aria-selected', 'true');
    } else {
    tab.setAttribute('tabindex', '-1');
    // tabPanels[index].setAttribute('hidden', '');
    tabPanels[index].style.display = 'none';

    }
})

tabPanels.forEach((panel) => {
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('tabindex', '0');
});

tabsList.addEventListener('click', (e) => {
    const clickedTab = e.target.closest('a');
    if (!clickedTab) return;
    e.preventDefault();

    switchTab(clickedTab);
});
tabsContainer.addEventListener('keydown', (e) => {
    switch (e.key) {
        case 'ArrowUp':
            e.preventDefault();
            moveUp();
            break;
        case 'ArrowLeft':
            moveUp();
            break;
        case 'ArrowDown':
            e.preventDefault();
            moveDown();
            break;
        case 'ArrowRight':
            moveDown();
            break;
        case 'Home':
            e.preventDefault();
            switchTab(tabButtons[0]);
            break;
        case 'End':
            e.preventDefault();
            switchTab(tabButtons[tabButtons.length - 1]);
            break;
    }    
});

function moveUp() {
    const currentTab = document.activeElement;
    if (!currentTab.parentElement.previousElementSibling) {
        switchTab(tabButtons[tabButtons.length - 1]);
    } else {
    switchTab(
        currentTab.parentElement.previousElementSibling.querySelector('a')
    );
    }
}

function moveDown() {
    const currentTab = document.activeElement;
    if (!currentTab.parentElement.nextElementSibling) {
        switchTab(tabButtons[0]);
    } else {
    switchTab(
        currentTab.parentElement.nextElementSibling.querySelector('a')
    );
    }
}

function switchTab(newTab) {
  const activePanelId = newTab.getAttribute('href');
  const activePanel = tabsContainer.querySelector(activePanelId);

  tabButtons.forEach((button) => {
    button.setAttribute('aria-selected', 'false');
    button.setAttribute('tabindex', '-1');
  });

  tabPanels.forEach((panel) => {
    // panel.setAttribute('hidden', true);
    // Set style display none
    panel.style.display = 'none';

  });

  activePanel.style.display = 'flex';
  //   activePanel.removeAttribute('hidden');
  newTab.setAttribute('aria-selected', 'true');
  newTab.setAttribute('tabindex', '0');
  newTab.focus();


  // Actualizar el hash en la URL
  history.pushState(null, "", activePanelId);
}




window.addEventListener('DOMContentLoaded', (event) => {
  const hash = window.location.hash;
  if (hash) {
    const initialTab = tabsContainer.querySelector(`a[href="${hash}"]`);
    if (initialTab) {
      switchTab(initialTab);
    }
  }
});

// Manejar cambios en el hash
window.addEventListener('hashchange', (event) => {
  const hash = window.location.hash;
  const tabToActivate = tabsContainer.querySelector(`a[href="${hash}"]`);
  if (tabToActivate) {
    switchTab(tabToActivate);
  }
});
window.addEventListener('popstate', (event) => {
  const hash = window.location.hash;
  const tabToActivate = tabsContainer.querySelector(`a[href="${hash}"]`);
  if (tabToActivate) {
    switchTab(tabToActivate);
  }
});


// On click backbtn prevent default if history.length is not null, is it exists the original URL from the link is used
document.getElementById("backbtn").addEventListener("click", function(e){
  if (history.length){
    e.preventDefault();
    history.back();
    return false;
  }
}
);